import { render, staticRenderFns } from "./member_top.vue?vue&type=template&id=6800d5d9&scoped=true"
import script from "./member_top.vue?vue&type=script&lang=js"
export * from "./member_top.vue?vue&type=script&lang=js"
import style0 from "./member_top.vue?vue&type=style&index=0&id=6800d5d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6800d5d9",
  null
  
)

export default component.exports